/* src/app/views/area-publica/detalhes-projeto/details-project-public/details-project-public.component.scss */
.title {
  font-size: 32px;
  font-weight: 500;
  color: #ffffff;
}
.project-content {
  background-color: #ffffff;
}
.project-content .header .title {
  font-size: 32px;
  font-weight: 500;
  color: #007AC2;
}
.project-content .selected-users .user-pic {
  height: 24px;
  border-radius: 50px;
  object-fit: cover;
}
.project-content .selected-users .responsable-chip {
  border: 1px solid #E6D026;
  border-radius: 20px;
}
.project-content .chip-close-btn {
  font-size: 16px;
  color: #C21E00;
}
.project-content .tabs .title {
  font-size: 24px;
  font-weight: 500;
  color: #007AC2;
  padding: 2% 0;
}
.drawer {
  width: 363px;
  box-shadow: -10px 0px 20px rgba(0, 0, 0, 0.1607843137);
}
.drawer.position-fixed {
  position: fixed;
}
.drawer ::ng-deep ::-webkit-scrollbar {
  display: none;
}
.drawer .drawer-margin {
  margin: 5%;
  overflow-y: hidden;
}
.drawer .drawer-title {
  font-size: 32px;
  font-weight: 500;
  color: #007AC2;
}
.drawer .drawer-content {
  height: 85vh;
  overflow-y: auto;
}
.drawer .drawer-content .drawer-content-title {
  font-size: 14px;
  font-weight: 700;
  color: #2E3241;
}
.drawer .drawer-content .mat-mdc-chip {
  background-color: #fafafa;
}
.capa-projeto {
  width: 100%;
  max-height: 275px;
  height: 275px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}
.label-projeto {
  width: 100%;
  background: rgba(46, 50, 65, 0.8);
  opacity: 0.8;
  position: absolute;
  bottom: 0;
  padding: 25px 40px 25px 40px;
}
.item-label-projeto {
  display: block;
}
.container-dados-projeto {
  width: 80%;
  margin: auto;
}
.descricao-projeto {
  width: 60%;
  margin: auto;
  padding-top: 40px;
}
#texto-html-projeto {
  max-height: 265px;
  border: 0 solid transparent;
  border-width: 10px 0;
  padding-bottom: 50px;
  overflow-wrap: break-word;
}
:host ::ng-deep #texto-html-projeto img,
:host ::ng-deep #texto-html-projeto p img,
:host ::ng-deep #texto-html-projeto > img,
:host ::ng-deep #texto-html-projeto p > img {
  max-width: 100%;
}
.wrapper {
  position: relative;
}
.wrapper:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 50px;
}
.wrapper:after {
  bottom: 0;
  background-image:
    linear-gradient(
      to top,
      rgb(255, 255, 255),
      rgba(255, 255, 255, 0));
}
.overflow-hidden-content {
  overflow: hidden;
}
.btns-crop-descricao-projeto,
.btn-voltar-catalogo {
  font-size: 16px;
  color: #007ac2;
  cursor: pointer;
  font-family: "Alegreya Sans Regular", sans-serif;
}
.descricao-projeto-expandido {
  max-height: fit-content !important;
  padding-bottom: 0 !important;
}
:host ::ng-deep .ql-align-right {
  text-align: right;
}
:host ::ng-deep .ql-align-center {
  text-align: center;
}
:host ::ng-deep .ql-align-left {
  text-align: left;
}
#container-banner-projeto {
  background: rgba(46, 50, 65, 0.3);
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=details-project-public.component.css.map */
